import { render, staticRenderFns } from "./CompetitorsContrast.vue?vue&type=template&id=6b91bac4&scoped=true"
import script from "./CompetitorsContrast.vue?vue&type=script&lang=js"
export * from "./CompetitorsContrast.vue?vue&type=script&lang=js"
import style0 from "./CompetitorsContrast.vue?vue&type=style&index=0&id=6b91bac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b91bac4",
  null
  
)

export default component.exports